module.exports = __webpack_public_path__ + "static/media/05.6fbe9140.png";